import { toastError } from 'utils';
const serverErrorLoggingMiddleware = ({}) => (next) => (action) => {
    if ((action?.type?.includes('@@lp-redux-api') ||
        action?.type?.includes('merchantPortalApi') ||
        action?.type?.includes('consumerPortalApi')) &&
        (action?.payload?.status === 'failure' || action?.error?.message)) {
        const errorStatus = action.payload?.data?.status ?? action.payload?.status;
        const serverErrors = errorStatus >= 500 && errorStatus <= 599; //503 wont be passed here, will already be rerouted
        if (serverErrors) {
            toastError(`Server Error: ${errorStatus}`);
        }
    }
    return next(action);
};
export default serverErrorLoggingMiddleware;
